import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useCreateRecurringTemplate } from "@/api/financial";
import { PageHeader } from "@/components/PageHeader";
import { RecurringTemplateForm } from "./-components/RecurringTemplateForm";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/financial/recurring/new",
)({
	component: NewRecurringTemplatePage,
});

function NewRecurringTemplatePage() {
	const { orgId } = Route.useParams();
	const { t } = useTranslation();
	const navigate = Route.useNavigate();

	const createMutation = useCreateRecurringTemplate();

	const goToList = () =>
		navigate({ to: "/app/org/$orgId/financial/recurring", params: { orgId } });

	return (
		<div className="mx-auto flex w-full max-w-2xl flex-col gap-6">
			<PageHeader
				title={t("financial.recurring.form.newTitle")}
				showBackButton
			/>
			<div className="card bg-base-100 shadow-md">
				<div className="card-body">
					<RecurringTemplateForm
						orgId={orgId}
						isSubmitting={createMutation.isPending}
						onSubmit={(data) =>
							createMutation
								.mutateAsync({ organizationId: orgId, data })
								.then(() => goToList())
						}
						onCancel={goToList}
					/>
				</div>
			</div>
		</div>
	);
}
